import {
    type AfterViewInit,
    Component,
    inject,
    ChangeDetectionStrategy,
} from "@angular/core";
import { DATA_QAA, dataQaaPrefix } from "@firm360/libs/observability/data-qaa";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "app-500",
    templateUrl: "500.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    hostDirectives: [DATA_QAA],
})
export class P500Component implements AfterViewInit {
    protected readonly qaaPrefix = dataQaaPrefix(P500Component);
    private modalService = inject(NgbModal);

    ngAfterViewInit() {
        this.modalService.dismissAll();
    }
}
